export default __webpack_public_path__ + "_/images/freespins/freespins-40-e8266ab83cee26a5f573e35ba60f4fad37a06865fa3b5d0ebe536fa6d761408c.png";